import { FC } from 'react';
import { closeQAMenu, useQAMenu } from '../../pages/Login/useLogin';
import { Card } from '../Card';
import { Modal } from '../Modal';
import cx from 'clsx';
import styles from './EnvModal.module.css';
import { SYSTEM_ENV } from '../../constants.ts';

interface EnvModalProps {}

export const EnvModal: FC<EnvModalProps> = () => {
  const open = useQAMenu();

  return (
    <Modal title="Enviroment select" open={open} onClose={closeQAMenu}>
      <div className={styles.container}>
        <Card
          className={cx(SYSTEM_ENV === 'test' && styles.active)}
          onClick={() => {
            window.location.href = 'https://lcv-driver-app-test.ruptela.lt/';
          }}
        >
          Test
        </Card>
        <Card
          className={cx(SYSTEM_ENV === 'prep' && styles.active)}
          onClick={() => {
            window.location.href = 'https://lcv-driver-app-prep.ruptela.lt/';
          }}
        >
          Prep
        </Card>
        <Card
          className={cx(SYSTEM_ENV === 'prod' && styles.active)}
          onClick={() => {
            window.location.href = 'https://journey.fm-track.com/';
          }}
        >
          Prod
        </Card>
      </div>
    </Modal>
  );
};
